import { render, staticRenderFns } from "./NormalSearchNav660.vue?vue&type=template&id=2125519a&scoped=true"
import script from "./NormalSearchNav660.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav660.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2125519a",
  null
  
)

export default component.exports